import React from "react";
import api from "../api";

export const fetchProductsApi = async () => {
  const response = await api.get("/product");
  return response.data;
};
